










import Vue from 'vue'

interface ComponentData {
  text: string
}

export default Vue.extend({
  name: 'TextAreaCellRenderer',

  data (): ComponentData {
    return {
      text: ''
    }
  },

  watch: {
    text(newVal: string): void {
      // @ts-ignore
      this.params.data.note = newVal
    }
  },

  mounted () {
    // @ts-ignore
    if(this.params.data.note) {
      // @ts-ignore
      this.text = this.params.data.note
    }
  }
})
